import React from 'react';
import './FilesSection.css';

import { Container, Row, Col } from 'reactstrap';
import { DeleteImageIcon } from '../elements/icons/Icons';
import { FileLoader } from '../elements/fileLoader/FileLoader';

const FilesSection = ({ elements, deleteFile, rankIndex, loading }) => {
    return (
        <div className="FilesSection">
            {elements &&
                elements.length > 0 &&
                elements.map((media, index) => {
                    return (
                        <div className="uploadedPicture">
                            <div className="uploadedPictureWrapper">
                                <img
                                    alt={`image#${index}`}
                                    key={index}
                                    className={'img-thumbnail'}
                                    src={media.downloadMediaUrl}
                                />
                                <div
                                    className="deleteButton"
                                    onClick={() => {
                                        rankIndex ? deleteFile(rankIndex) : deleteFile(index);
                                    }}
                                >
                                    <DeleteImageIcon />
                                </div>
                            </div>
                        </div>
                    );
                })}
            {loading && (
                <div className="uploadedPicture">
                    <FileLoader />
                </div>
            )}
        </div>
    );
};

export default FilesSection;
